import React from 'react';

const Loader = ({ small }) => (
  <div class="text-center">
    <img class="demo-mw-50" style={{ width: small ? 20 : null }} src="/img/progress.svg" alt="Progress" />
  </div>
);

export default Loader;
